import { LabelType } from './HighlightCard';
import { css } from 'emotion';

import { colors, fonts } from '../styles';

export const container = css`
  display: flex;
  flex-direction: row;
  align-items: end;
`;

export const labelContent = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  &:not(:first-child) {
    margin-left: 6px;
  }

  & > *:not(:first-child) {
    margin-left: 6px;
  }
`;

export const value = (active: boolean) => css`
  line-height: 29px;
  font-size: 32px;
  font-weight: ${active ? fonts.weight.bold : fonts.weight.light};
  color: ${colors.black};
`;

export const label = (labelType: LabelType, active: boolean) => css`
  line-height: 29px;
  font-size: ${labelType === LabelType.Text ? fonts.size.large : fonts.size.largest};
  font-weight: ${active ? fonts.weight.regular : fonts.weight.light};
  color: ${colors.black};
`;

export const item = css`
  padding: 30px 20px;
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: center;
`;

export const titleWrapper = css`
  margin: 10px 0 0;
`;

export const titleText = (active: boolean) => css`
  display: block;
  line-height: 19px;
  text-align: left;
  font-size: ${fonts.size.small};
  font-weight: ${active ? fonts.weight.medium : fonts.weight.regular};
  color: ${colors.gray.dark};
`;
